<template>
  <div class="pay-list">
    <p class="title-left ljb-base-padding ljb-border">{{ title }}</p>
    <ul class="ljb-x-padding ">
      <li
        v-for="(item,key) in payList"
        :key="key"
        class="ljb-item_cell pay-item ljb-border"
        @click="selectPayWay(item,key)">
        <div class="left">
          <img
            :src="item.src"
            class="pay-icon">
          <span class="type">{{ item.name }}</span>
        </div>
        <span
          :class="isItemActivity(item)"
          class="right"/>
      </li>
    </ul>
  </div>
</template>

<script>
import TextTitle from '@/components/title/TextTitle'
export default {
  name: 'PayList',
  components: {TextTitle},
  model: {
    prop: 'payType',
    event: 'selectPayWay'
  },
  data () {
    return {
      title: '支付方式',
      payInfo: {
      }
    }
  },
  computed: {
    payList () {
      let list = []
      let wx = {
        src: 'https://cdn.51ljb.cn/ljb-icons-wxPay.png',
        name: '微信支付',
        type: this.$dataResource.payType.wxPay
      }

      let aliPay = {
        src: 'https://cdn.51ljb.cn/ljb-icons-zfbPay.png',
        name: '支付宝支付',
        type: this.$dataResource.payType.aliPay
      }

      if (!this.$utils.isWxgzh()) {
        list.push(aliPay)
      }
      list.push(wx)
      this.selectPayWay(wx)
      return list
    }
  },
  methods: {
    selectPayWay: function (item, key) {
      this.payInfo = item
      this.$emit('selectPayWay', item.type)
    },
    isItemActivity (item) {
      console.log(' item ', item)
      console.log(' this.payInfo ', this.payInfo)
      let className = ''
      if (this.payInfo.type === item.type) {
        className = 'active'
      }
      return className
    }

  }
}
</script>

<style lang="scss" scoped>
.pay-list{
  background: #fff;
  line-height: 16px;
  li:nth-last-child(1){
    border:none;
  }
  .left{
    position: relative;
    .type{
      margin-left: 40px;
      font-size: 16px;
      font-weight: normal;
      font-family: "PingFangSC-Regular";
      color: #666666
    }
  }
  .pay-icon{
    width: 24px;
    height: 24px;
    position: absolute;
    top:17px
    /*margin-top: 7px;*/
    /*margin-right:10px ;*/
}
  .right{
    width: 20px;
    height: 20px;
    // border:1px solid #999;
    border-radius: 50%;
    box-sizing: border-box;
    &.active{
      background: url('https://cdn.51ljb.cn/ljb_icons_choose_active.png') no-repeat left;
      background-size:20px 20px ;
      border:none;
    }
  }
}
.pay-item{
  line-height: 57px;
}
  .title-left{
    font-size: 15px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/pay/payList.vue